// removed by extract-text-webpack-plugin
module.exports = {"authorLink":"_18pQ2","didYouMeanLink":"_3ysjU","authorText":"_1jmp0","didYouMeanText":"_1HfAt","seoHeading":"_2EEUe","seoSubHeading":"_2u0Bx"};